import { render, staticRenderFns } from "./DataTableItemFormattedCurrency.vue?vue&type=template&id=0117222e&"
import script from "./DataTableItemFormattedCurrency.vue?vue&type=script&lang=ts&"
export * from "./DataTableItemFormattedCurrency.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports